import { generateCardForCategory } from "../admin/category_utils";

export async function initCategories(getUrl){
    const resp = await fetch(getUrl);

    if(!resp.ok){
        console.error("Oh no! Cannot load categories");
        document.querySelectorAll("[data-container='nodata']").forEach(e => e.classList.add("d-none"));
        return;
    }

    const data = await resp.json();

    if(data.pageTotal > 0){
        document.querySelectorAll("[data-container='nodata']").forEach(e => e.classList.add("d-none"));
    }

    data.results?.forEach(cat => document.getElementById("categoryCards").appendChild(generateCardForCategory(cat, false)));
}